import { isSupabaseConfigured, supabase } from './supabase';

export const vapidPublicKey = (import.meta.env.VITE_VAPID_PUBLIC_KEY || '') as string;
export const isPushConfigured = Boolean(vapidPublicKey && isSupabaseConfigured);

function urlBase64ToUint8Array(base64String: string) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

function arrayBufferToBase64(buffer: ArrayBuffer | null) {
  if (!buffer) return '';
  const bytes = new Uint8Array(buffer);
  let binary = '';
  bytes.forEach((byte) => (binary += String.fromCharCode(byte)));
  return btoa(binary);
}

export async function subscribeToPush() {
  if (!isPushConfigured || !supabase) throw new Error('الإشعارات الخلفية تحتاج VAPID Public Key أولاً.');
  if (!('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) {
    throw new Error('هذا المتصفح لا يدعم إشعارات الويب الخلفية.');
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('لازم المستخدم يوافق على الإشعارات أولاً.');

  const registration = await navigator.serviceWorker.register('/sw.js');
  const current = await registration.pushManager.getSubscription();
  const subscription = current || (await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
  }));

  const json = subscription.toJSON();
  const p256dh = json.keys?.p256dh || arrayBufferToBase64(subscription.getKey('p256dh'));
  const auth = json.keys?.auth || arrayBufferToBase64(subscription.getKey('auth'));

  const { error } = await supabase.rpc('save_push_subscription', {
    subscription_data: {
      endpoint: subscription.endpoint,
      p256dh,
      auth,
    },
  });
  if (error) throw error;
  return true;
}

export async function sendPushNotification(payload: { title: string; body: string; url?: string }) {
  if (!supabase) throw new Error('Supabase غير مربوط.');
  const { data, error } = await supabase.functions.invoke('send-push', { body: payload });
  if (error) throw new Error(error.message || 'تعذر إرسال الإشعار.');
  return data;
}
